import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qamaria_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getToken = () => localStorage.getItem("qamaria_token");

export const fmt = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  return `${Number(n).toLocaleString("en-US")} د.ع`;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "حدث خطأ، حاول مرة أخرى";
};

export const waLink = (phone, text = "") => {
  const clean = String(phone || "").replace(/[^0-9]/g, "");
  const num = clean.startsWith("964") ? clean : `964${clean.replace(/^0/, "")}`;
  return `https://wa.me/${num}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

export const telLink = (phone) => `tel:${String(phone || "").replace(/[^0-9+]/g, "")}`;

export const fmtTime = (t) => {
  if (!t) return "";
  const [h, m] = String(t).split(":").map(Number);
  const p = h >= 12 ? "م" : "ص";
  const hh = h % 12 || 12;
  return `${hh}:${String(m).padStart(2, "0")} ${p}`;
};

export const fmtRange = (s, e) => (s ? `${fmtTime(s)} - ${fmtTime(e)}` : "");

export const eventTypes = ["عرس", "حنة", "خطوبة", "مناسبة أخرى"];

export const resolveImg = (src) => {
  if (!src) return src;
  if (src.startsWith("file:")) return `${API}/public/files/${src.slice(5)}`;
  return src;
};

export const downloadExport = async (kind, format, params = {}) => {
  const res = await api.get(`/admin/export/${kind}`, { params: { format, ...params }, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url; a.download = `${kind}.${format}`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};
